import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useMutation } from './mutation.js';
import { api, type AppelApi } from './client.js';
import { appelDeRequete, cleMetier, dansLaPortee } from './cles.js';

export interface IdentiteSso {
  readonly id: string;
  readonly compteId: string;
  readonly email: string;
  readonly emetteur: string;
  readonly lieLe: string;
  readonly derniereConnexionLe: string | null;
}
const chemin = (galerie: string) => `/g/${encodeURIComponent(galerie)}/sso/identites`;
export const ssoApi = {
  listerIdentites: (galerie: string, appel?: AppelApi) =>
    api.get<{ identites: IdentiteSso[] }>(chemin(galerie), { galerie, ...appel }),
  delier: (galerie: string, id: string, appel?: AppelApi) =>
    api.delete<{ identite: IdentiteSso }>(`${chemin(galerie)}/${encodeURIComponent(id)}`, {
      galerie,
      ...appel,
    }),
};
export function useIdentitesSso(galerie: string, actif: boolean) {
  return useQuery({
    queryKey: cleMetier(galerie, 'sso', 'identites'),
    queryFn: (contexte) => ssoApi.listerIdentites(galerie, appelDeRequete(contexte)),
    enabled: actif,
  });
}
export function useDelierIdentite(galerie: string) {
  const client = useQueryClient();
  return useMutation(
    dansLaPortee({
      gcTime: 0,
      mutationFn: (id: string, appel) => ssoApi.delier(galerie, id, appel),
      onSuccess: () => {
        void client.invalidateQueries({ queryKey: cleMetier(galerie, 'sso', 'identites') });
      },
    }),
  );
}
